module.exports = __webpack_public_path__ + "img/team.b4054983.jpg";